import React, { useState, useEffect } from "react";
import "../css/chat-button.css";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import SmsIcon from "@mui/icons-material/Sms";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ChatInvite(props) {
  const { env, openWindow, msgHistory } = props;
  const hide = () => {
    const id = document.querySelector(".Inv");
    id.style.display = "none";

    openWindow(true);
  };

  if (msgHistory.length != 2) {
    return <div className="Inv"></div>;
  }
}
if (window.screen.width < 500) {
  var isMobile = true;
} else {
  var isMobile = false;
}

function ChatButton(props) {
  const { openWindow, newMsgNum, chatWindowStatus } = props;
  const [iconIsChanging, setIconIsChanging] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);

  useEffect(() => {
    setIconIsChanging(true); // Start animation

    // Clear the animation flag after a timeout
    const timeoutId = setTimeout(() => setIconIsChanging(false), 700);

    return () => clearTimeout(timeoutId);
  }, [chatWindowStatus]);

  const hide = () => {
    const id = document.querySelector(".Inv");
    id.style.display = "none";
    const chatBtnContainer = document.querySelector(".chat-btn-container");
    chatBtnContainer.addEventListener("click", function () {
      setBtnClicked(true);

      // Remove the class after a slight delay
      setTimeout(() => {
        setBtnClicked(false);
      }, 200); // Adjust delay to match bounce duration
    });
  };

  return (
    <div
      className={`chat-btn-container ${chatWindowStatus ? "no-ripple" : ""} ${btnClicked ? "clicked" : ""
        } ${chatWindowStatus && isMobile ? "hidden" : ""}`}
      onClick={hide}
      id="btn-container"
    >
      <Badge
        badgeContent={newMsgNum}
        invisible={newMsgNum === 0}
        color="warning"
        ripple
      >
        <IconButton
          className="chat-button"
          color="primary"
          tabIndex={-1}
          variant="SmsIcon"
          style={{
            borderRadius: "50%",
            backgroundColor: "var(--brand-1)",
            zIndex: "1",
          }}
          onClick={() => {
            openWindow(true);
            blur();
            document.activeElement.blur();
          }}
          onInput={blur()}
          onFocus={blur()}
          inputMode="none"
          aria-readonly="true"
          onInputCapture={() => {
            blur();
            document.activeElement.blur();
          }}
          aria-label="Open Chat Window"
        >
          {chatWindowStatus ? (
            <ExpandMoreIcon
              style={{ color: "white" }}
              className={iconIsChanging ? "slide-fade-enter-active" : ""}
            />
          ) : (
            <SmsIcon
              style={{ color: "white" }}
              className={iconIsChanging ? "slide-fade-enter-active" : ""}
            />
          )}
        </IconButton>
      </Badge>
    </div>
  );
}

function ChatCloseBtn(props) {
  const { openWindow } = props;
  return (
    <div className="chat-btn-container">
      <IconButton
        className="chatButton"
        aria-label="Close Chat Window"
        color="primary"
        style={{ borderRadius: "50%" }}
        onClick={() => {
          openWindow(false);
          document.activeElement.blur();
        }}
      >
        <CloseIcon style={{ color: "white" }} />
      </IconButton>
    </div>
  );
}

function ChatInviteRemake(props) {
  const { env, openWindow, msgHistory } = props;

  const avatarUrl = `https://storage.googleapis.com/${process.env.REACT_APP_ROOT_CSS_BUCKET}/avatars/${env.agentId}_${env.environmentId}.png?timestamp=${new Date().getTime()}`;

  const hide = () => {
    const id = document.querySelector(".Inv");
    id.style.display = "none";

    openWindow(true);
  };
  window.parent.postMessage(
    {
      type: "handleChatInviteRemake",
      data: msgHistory != null && msgHistory.length <= 3,
    },
    "*"
  );
  const lang = props.lang;
  if (msgHistory != null && msgHistory.length <= 3) {
    if (lang == "FR") {
      if (isMobile) {
        return (
          <div className="Inv mobile">
            <img alt="Avatar" src={avatarUrl} onClick={hide}></img>
            <Box
              className="avatarBox mobile"
              onClick={() => {
                hide();
              }}
            >
              {env.FR.greetingMessage}
            </Box>
          </div>
        );
      } else {
        return (
          <div className="Inv">
            <img alt="Avatar" src={avatarUrl} onClick={hide}></img>
            <Box
              className="avatarBox"
              onClick={() => {
                hide();
              }}
              role="button"
              tabIndex={0}
              aria-label="Welcome Message"
            >
              {env.FR.greetingMessage}
            </Box>
          </div>
        );
      }
    } else {
      if (isMobile) {
        return (
          <div className="Inv mobile">
            <img alt="Avatar" src={avatarUrl} onClick={hide}></img>
            <Box
              className="avatarBox mobile"
              onClick={hide}
              role="button"
              tabIndex={0}
              aria-label="Welcome Message"
            >
              {env.EN.greetingMessage}
            </Box>
          </div>
        );
      } else {
        return (
          <div className="Inv">
            <img alt="Avatar" src={avatarUrl} onClick={hide}></img>
            <Box
              className="avatarBox"
              onClick={hide}
              role="button"
              tabIndex={0}
              aria-label="Welcome Message"
            >
              {env.EN.greetingMessage}
            </Box>
          </div>
        );
      }
    }
  } else {
    return <div className="Inv"></div>;
  }
}

export { ChatButton, ChatCloseBtn, ChatInvite, ChatInviteRemake };
